export default __webpack_public_path__ + "static/media/charles-forerunner-3fPXt37X6UQ-unsplash.d041c06f.jpg";